import { toMB } from '@/utils'
import type { DataCollector } from './types'

// LOADING COLLECTOR - Measures duration between start() and collect()
export function loadingCollector(): DataCollector {
  let startTime: number | null = null
  let isCached = false

  return {
    start(initialData?: any) {
      startTime = performance.now()
      isCached = initialData?.isCached || false
    },
    collect() {
      const endTime = performance.now()
      const duration = startTime ? (endTime - startTime) / 1000 : 0

      return {
        duration,
        timestamp: Date.now(),
        isCached,
      }
    },
  }
}

// MEMORY COLLECTOR - Captures memory usage snapshot
export function memoryCollector(): DataCollector {
  return {
    collect() {
      const timestamp = Date.now()

      if (performance.memory?.usedJSHeapSize) {
        return {
          type: 'js-heap',
          timestamp,
          usedJSHeapSize: performance.memory.usedJSHeapSize,
          totalJSHeapSize: performance.memory.totalJSHeapSize,
          jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
          memoryUsageMB: toMB(performance.memory.usedJSHeapSize),
          totalHeapSizeMB: toMB(performance.memory.totalJSHeapSize),
          heapLimitMB: toMB(performance.memory.jsHeapSizeLimit),
        }
      }

      if (
        window.crossOriginIsolated &&
        'measureUserAgentSpecificMemory' in performance
      ) {
        performance
          .measureUserAgentSpecificMemory()
          .then((result) => {
            return {
              type: 'user-agent-specific',
              timestamp,
              memoryUsageMB: result.bytes / 1024 / 1024,
            }
          })
          .catch(() => {})
      }

      return {
        type: 'null',
        timestamp,
        memoryUsageMB: 0,
      }
    },
  }
}
